<template><svg width="12" stroke-width="3" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L3 9l8 8" fill="none"/></svg></template>